import { render, staticRenderFns } from "./SubmitJob.vue?vue&type=template&id=53153f66&scoped=true"
import script from "./SubmitJob.vue?vue&type=script&lang=js"
export * from "./SubmitJob.vue?vue&type=script&lang=js"
import style0 from "./SubmitJob.vue?vue&type=style&index=0&id=53153f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53153f66",
  null
  
)

export default component.exports